import { ProductPage } from "./ProductPage";
import { buildTv6Config } from "./configs/tv6";

export function Tv6Page() {
  return <ProductPage build={buildTv6Config} />;
}
